export const ReturnsTableColumns = [
    {
        id: "return_number",
        labelEn: "Return #",
        labelAr: "رقم المرتجع",
        align: "left",
        sortable: true,
    },
    {
        id: "order_number",
        labelEn: "Order #",
        labelAr: "رقم الطلب",
        align: "left",
        sortable: false,
    },
    {
        id: "customer",
        labelEn: "Customer",
        labelAr: "العميل",
        align: "left",
        sortable: false,
    },
    {
        id: "status",
        labelEn: "Status",
        labelAr: "الحالة",
        align: "center",
        sortable: true,
    },
    {
        id: "refund_amount",
        labelEn: "Refund",
        labelAr: "قيمة الاسترداد",
        align: "center",
        sortable: false,
    },
    {
        id: "requested_at",
        labelEn: "Requested",
        labelAr: "تاريخ الطلب",
        align: "center",
        sortable: true,
    },
];
